import React from "react";
import { connect } from "react-redux";
import { chatActions } from "../../../../../_actions";
import { language, translate } from "../../../../../_helpers/general.helper";

import {
  ApartmentInfo,
  ApartmentInfoEmptyPrice,
  DescImg,
  Description,
  DetailsContainer,
  BedroomDescription,
  DisclaimerAndInfoWrapper,
} from "./styles";

function Details({ data, onClick, onKeyPress, send, tid }) {
  const info = data.info;
  const priceDescParsed = data.price_desc && JSON.parse(data.price_desc);

  let bedroom;
  let bathroom;
  let surfaceArea;
  let surfaceAreaTo;
  let surfaceAreaUnit;
  let description;

  const isStudent = data?.bot_type === "Student";

  if (info) {
    bedroom = info.bedroom;
    bathroom = info.bathroom;
    surfaceArea = info.surfaceArea;
    surfaceAreaTo = info.surfaceAreaTo;
    surfaceAreaUnit = info.surfaceAreaUnit;
  }

  if (data.desc) {
    description = data.desc;
  }

  let priceDesc;
  let actualPrice;
  let actualPriceNumOfDigits;

  let hasPrice = 0;
  let hasDesc = 0;
  let hasLargePrice = 0;

  if (priceDescParsed.length != 0) {
    hasDesc = 1;
    hasPrice = priceDescParsed[0].price;
    if (hasPrice) {
      priceDesc = priceDescParsed[0].text
        .substr(
          priceDescParsed[0].text,
          priceDescParsed[0].text.lastIndexOf("$")
        )
        .trim();
      const currency = priceDescParsed[0].text
        .substr(priceDescParsed[0].text.indexOf("$"), 1)
        .trim();
      actualPriceNumOfDigits = priceDescParsed[0].price.toString().length;
      hasLargePrice = actualPriceNumOfDigits >= 5;
      actualPrice = `${currency} ${priceDescParsed[0].price
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
    } else {
      priceDesc = priceDescParsed[0].text;
    }
  }

  const handleClick = () => {
    const sendData = {
      ...data,
      value: "NearbyProperties-NearbyPropertiesConversation?" + data.name,
      text: translate("View Similar Floorplans Nearby", language(tid)),
    };
    send(sendData, "text");
  };

  const handleClickQuicklink = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      handleClick();
    }
  };

  const bedroomDescJsx = bedroom ? (
    <Description className="Description" >
      <div className="info-image">
        <span className="info-number">{bedroom.bedrooms}</span>
        <DescImg src={`/images/light-mode/Bed.svg`} />
      </div>
      <span className="info-description">{bedroom.text}</span>
    </Description>
  ) : (
    <Description className="Description">
    <div className="info-image">
      <span className="info-number"> </span>
      <DescImg src={`/images/light-mode/Bed.svg`} />
    </div>
    <span className="info-description">{info.type}</span>
  </Description>
  );

  const bathroomDescJsx = bathroom && (
    <Description className="Description" hasDesc={hasDesc}>
      <div className="info-image">
        <span className="info-number">{bathroom.bathrooms}</span>
        <DescImg src={`/images/light-mode/Bath.svg`} />
      </div>
      <span className="info-description">{bathroom.text}</span>
    </Description>
  );

  const priceAndDescJsx = surfaceArea && (
    <Description className="Description">
      <div className="info-image">
        <span className="info-number">{surfaceArea}{surfaceAreaTo != surfaceArea ? "-"+surfaceAreaTo : "" }</span>
      </div>
      <span className="info-description">{surfaceAreaUnit}</span>
    </Description>
  );

  const unitsAvailable = (numberUnits) => { 
    return (
    <Description className="Description" hasDesc={hasDesc}>
      <div className="info-image">
        <span className="info-number">{data.available_units}</span>
        <DescImg src={`/images/light-mode/Square.svg`} />
      </div>
      <span className="info-description">{numberUnits !== 1 ? translate('Units available', language(tid)):  translate('Unit available', language(tid)) }</span>
    </Description>
  )};

  const unitsAvailableStudent = (units) => {
    if(units) {
    return (
      <Description className="Description mr-4" hasDesc={hasDesc}>
      <div className="info-image">
        <span className="info-number">{data.units.length}</span>
      </div>
      <span className="info-description">{translate('Room types', language(tid))}</span>
    </Description>
   
    )
  }

  } 

  return (
    <DetailsContainer className="DetailsContainer">
      <DisclaimerAndInfoWrapper className="DisclaimerAndInfoWrapper">
        {data.info && (
          <div className="ApartmentInfoWrapper">
              <ApartmentInfo className="ApartmentInfo">
                {data.units_data === '1' && !isStudent &&  (
                  <div>{unitsAvailable(data.units && data.units.length)}</div>
                )}
                  {isStudent && (
                  <div>{unitsAvailableStudent(data.units && data.units.length)}</div>
                )}
                <div>
                  {bedroomDescJsx}
                  {bathroomDescJsx}
                  {priceAndDescJsx}
                </div>
              </ApartmentInfo> 
          </div>
        )}
      </DisclaimerAndInfoWrapper>

      {description && (
        <BedroomDescription className="BedroomDescription">
          <span>{description}</span>
        </BedroomDescription>
      )}
    </DetailsContainer>
  );
}

const mapStateToProps = (state) => ({
  quicklinks: state.chat.quicklinks,
  activeTheme: state.settings.activeTheme,
  tid: state.settings.tid,
});

const mapDispatchToProps = {
  send: chatActions.send,
};

export default connect(mapStateToProps, mapDispatchToProps)(Details);
